export enum AppState {
  Login = 'app.login',
  MobileLogin = 'app.mobile_login',
  PanelDashboard = 'app.panel_dashboard',
  PanelAcl = 'app.panel_acl',
  PanelVehicleList = 'app.panel_vehicle-list', // CONST.STATE.PANEL_VEHICLE_LIST.NAME (app.routes.js:92)
}
